const config = {
  BASE_URL: "https://o2742qo1jc.execute-api.eu-west-1.amazonaws.com/prod/",
  BASE_URL_DEV: "https://f5r9ke9cef.execute-api.eu-west-1.amazonaws.com/dev/",
};

export default config;
